import { SET_SUMMARY } from './types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_SUMMARY:
      return { ...state,
        categoricalSummary: action.summary.categoricalSummary,
        numericalSummary: action.summary.numericalSummary
      };
    default:
      return state;
  }
};
